import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../../services/app-config.service';
import { Cgu } from '../../models/textes-legaux/cgu';
import { map } from 'rxjs/operators';
import { MentionsLegales } from '../../models/textes-legaux/MentionsLegales';

@Injectable({
  providedIn: 'root'
})
export class TextesLegauxService {
  private apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
      this.apiUrl = _appConfig.config.servicesBaseUrl;
  }

    getCgu() {
        return this._http.get<Cgu>(this.apiUrl + `/media/cgu`)
            .pipe(map(data => {
                return data;
            }));
    }

  getMentionsLegales() {
    return this._http.get<MentionsLegales>(this.apiUrl + `/media/mentions-legales`)
        .pipe(map(ges => {
            return ges;
        }));
  }

}
